import { EmployerRoutingEnum } from '@features/employer/employer-routing.enum';
import { FeaturesRoutingEnum, FragmentsEnum } from '@features/features-routing.enum';
import { MenuTrackEventsEnum } from '@models/menu//navigation-tracker-actions.enum';

export interface NavItem {
  label: string;
  link?: string[];
  siteMapFooterLink?: string[];
  fragment?: FragmentsEnum;
  trackEventAction?: string;
  ariaLabel: string;
  dropdownItems?: NavItem[];
  queryParams?: Record<string, string>;
  new?: boolean;
}

export const MENU: NavItem[] = [
  {
    label: 'Emploi et stage',
    ariaLabel: 'Ouvrir la fenêtre de navigation des emplois.',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.Jobs],
    dropdownItems: [
      {
        label: 'Emploi',
        link: ['/', FeaturesRoutingEnum.Jobs],
        trackEventAction: MenuTrackEventsEnum.Emploi,
        ariaLabel: 'Je cherche un emploi.',
      },
      {
        label: 'Stage',
        link: ['/', FeaturesRoutingEnum.Internships],
        trackEventAction: MenuTrackEventsEnum.Stages,
        ariaLabel: 'Je cherche un stage.',
      },
      {
        label: 'Alternance',
        link: ['/', FeaturesRoutingEnum.Apprentice],
        trackEventAction: MenuTrackEventsEnum.Apprentissage,
        ariaLabel: "Je cherche un contrat d'alternance.",
      },
      {
        label: 'Job étudiant',
        link: ['/', FeaturesRoutingEnum.StudentJobs],
        trackEventAction: MenuTrackEventsEnum.JobsEtudiant,
        ariaLabel: 'Je cherche un job étudiant.',
      },
      {
        label: 'Emploi en Europe',
        link: ['/', FeaturesRoutingEnum.pfue],
        trackEventAction: MenuTrackEventsEnum.EmploiEurope,
        ariaLabel: 'Je cherche un emploi en Europe.',
      },

      // READ: keep this entry for future use next summer
      // {
      //   label: "Jobs d'été",
      //   link: ['/', FeaturesRoutingEnum.SummerJobs],
      //   trackEventAction: MenuTrackEventsEnum.JobsEte,
      //   ariaLabel: "Je cherche un job d'été.",
      // },
      {
        label: 'Entreprendre',
        link: ['/', FeaturesRoutingEnum.CreateCompany],
        trackEventAction: 'Click Entreprendre',
        ariaLabel: 'Je souhaite entreprendre.',
      },
      {
        label: 'Entreprendre à Marseille',
        link: ['/', FeaturesRoutingEnum.Marseille],
        trackEventAction: 'Click Entreprendre Marseille',
        ariaLabel: 'Je souhaite entreprendre à Marseille.',
      },
      {
        label: 'Vidéo de motivation',
        link: ['/', FeaturesRoutingEnum.Visiotalent],
        trackEventAction: MenuTrackEventsEnum.Visiotalent,
        ariaLabel: "J'enregistre ma vidéo de motivation.",
      },
      {
        label: 'Job Dating #1jeune1solution',
        link: ['/', FeaturesRoutingEnum.JobDating],
        trackEventAction: MenuTrackEventsEnum.JobDating,
        ariaLabel: 'Je participe à un jobdating.',
      },
    ],
  },
  {
    label: 'Orientation et formation',
    ariaLabel: 'Ouvrir la fenêtre de navigation des formations.',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.Trainings],
    dropdownItems: [
      {
        label: 'Formation',
        link: ['/', FeaturesRoutingEnum.Trainings],
        trackEventAction: MenuTrackEventsEnum.Formations,
        ariaLabel: 'Je cherche une formation.',
      },
      {
        label: 'CV personnalisé',
        link: ['/', FeaturesRoutingEnum.DiagorienteCv],
        trackEventAction: 'Click Créer CV',
        ariaLabel: 'Je crée un CV personnalisé.',
      },
      {
        label: 'Trouver mon métier',
        link: ['/', FeaturesRoutingEnum.DiagorienteInterests],
        trackEventAction: 'Click Trouver Mon Métier',
        ariaLabel: 'Je trouve mon métier.',
      },
      {
        label: 'Événements',
        link: ['/', FeaturesRoutingEnum.Events],
        trackEventAction: MenuTrackEventsEnum.Evenement,
        ariaLabel: 'Consulter les événements.',
      },
    ],
  },
  {
    label: 'Aides et accompagnement',
    ariaLabel: 'Ouvrir la fenêtre de navigation des aides.',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.AccessHelps],
    dropdownItems: [
      {
        label: 'Contrat Engagement Jeune',
        link: ['/', FeaturesRoutingEnum.CEJ],
        trackEventAction: 'Click CEJ',
        ariaLabel: "Le Contrat d'Engagement Jeune.",
        new: true,
      },
      {
        label: 'Mes aides financières',
        link: ['/', FeaturesRoutingEnum.AccessHelps],
        trackEventAction: MenuTrackEventsEnum.Aides,
        ariaLabel: 'Je découvre mes aides.',
      },
      {
        label: 'Accompagnement',
        link: ['/', FeaturesRoutingEnum.YouthInfoCenter],
        trackEventAction: 'Click Accompagnement',
        ariaLabel: "J'ai besoin d'un accompagnement.",
      },
      {
        label: 'Mentorat',
        link: ['/', FeaturesRoutingEnum.Mentoring],
        trackEventAction: MenuTrackEventsEnum.Mentorat,
        ariaLabel: 'Je trouve un mentor.',
      },
      {
        label: 'Les mesures jeunes',
        link: ['/', FeaturesRoutingEnum.Young],
        trackEventAction: MenuTrackEventsEnum.MesuresJeunes,
        ariaLabel: 'Je consulte les mesures jeunes.',
      },
    ],
  },
  {
    label: 'Engagement et bénévolat',
    ariaLabel: 'Ouvrir la fenêtre de navigation des engagements.',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.CivicService],
    dropdownItems: [
      {
        label: 'Le service civique',
        link: ['/', FeaturesRoutingEnum.CivicService],
        trackEventAction: MenuTrackEventsEnum.ServiceSivique,
        ariaLabel: 'Je cherche une mission de service civique.',
      },
      {
        label: 'Le bénévolat',
        link: ['/', FeaturesRoutingEnum.Volunteer],
        trackEventAction: MenuTrackEventsEnum.Benevolat,
        ariaLabel: 'Je cherche une mission de bénévolat',
      },
      {
        label: 'Tous les dispositifs',
        link: ['/', FeaturesRoutingEnum.Commitment],
        fragment: FragmentsEnum.CommitmentOtherOperator,
        trackEventAction: MenuTrackEventsEnum.CommitmentOtherOperator,
        ariaLabel: "Découvrir tous les dispositifs d'engagement.",
      },
    ],
  },
  {
    label: 'Actualités',
    link: ['/', FeaturesRoutingEnum.News],
    trackEventAction: 'Click Actualités',
    ariaLabel: 'Consulter les dernières actualités',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.News],
  },
  {
    label: 'Employeur',
    ariaLabel: 'Ouvrir la fenêtre de navigation des employeurs.',
    siteMapFooterLink: ['/', FeaturesRoutingEnum.Employers],
    dropdownItems: [
      {
        label: 'Recrutement',
        link: ['/', FeaturesRoutingEnum.Employers],
        trackEventAction: MenuTrackEventsEnum.Recruter,
        ariaLabel: 'Je recrute.',
      },
      {
        label: 'Rejoindre la mobilisation',
        link: ['/', FeaturesRoutingEnum.Companies],
        trackEventAction: MenuTrackEventsEnum.Mobilisation,
        ariaLabel: 'Je rejoins la mobilisation.',
      },
      {
        label: 'Mentorat',
        link: ['/', FeaturesRoutingEnum.Mentoring],
        trackEventAction: MenuTrackEventsEnum.DevenirMentor,
        ariaLabel: "S'engager dans le mentorat.",
      },
      {
        label: 'Les mesures employeurs',
        link: ['/', FeaturesRoutingEnum.Employers, EmployerRoutingEnum.Articles],
        trackEventAction: MenuTrackEventsEnum.MesuresEmployeurs,
        ariaLabel: 'Je consulte les mesures employeur.',
      },
    ],
  },
];
